import { Col } from "reactstrap";
import { H6, LI, UL } from "../../../../AbstractElements";
import { UnOrderListTitle } from "../../../../Constants/Constants";
import { UnOrderListData } from "../../../../Data/UiKits/Typography";

const UnOrderList = () => {
  return (
    <Col md="6" xxl="4">
      <div className="card-wrapper border rounded-3 bg-primary-light">
        <H6 className="sub-title fw-bold">{UnOrderListTitle}</H6>
        <UL className="simple-list">{UnOrderListData && UnOrderListData.map((item, index) => <LI key={index}>{item}</LI>)}</UL>
      </div>
    </Col>
  );
};
export default UnOrderList;
